import { render, staticRenderFns } from "./ArticleRegwall.vue?vue&type=template&id=54bc0bff&scoped=true"
import script from "./ArticleRegwall.vue?vue&type=script&lang=ts"
export * from "./ArticleRegwall.vue?vue&type=script&lang=ts"
import style0 from "./ArticleRegwall.vue?vue&type=style&index=0&id=54bc0bff&prod&lang=scss"
import style1 from "./ArticleRegwall.vue?vue&type=style&index=1&id=54bc0bff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc0bff",
  null
  
)

export default component.exports